module.exports = __webpack_public_path__ + "static/media/evo.f0840cf6.jpeg";